export default __webpack_public_path__ + "static/media/navbar-payment-pending-orange.a5b71efb.svg";